import { Menu, Typography } from "@mui/material";
import CallIcon from "@mui/icons-material/Call";
import type { JSX } from "react";

import { Keypad } from "./Keypad.js";

/**
 * In-call dial pad — enter an external phone number and dial it INTO the current
 * call's conference (C1 `webcast/dial_out`). The dialled party joins as an audio
 * participant, bridged to everyone in the room. Anchored above the floating call
 * window (which sits at zIndex.modal+1). Presentational — `onDial` does the work.
 *
 * The number field + 12-key grid live in the shared `<Keypad>` (reused by the
 * top-nav `CallLauncher`); this wraps it in the anchored Menu + the "Call a
 * phone number" heading and keeps the `dialpad-*` test ids.
 */
export function DialPad({
  anchorEl,
  onClose,
  onDial,
  busy,
}: {
  anchorEl: HTMLElement | null;
  onClose: () => void;
  onDial: (number: string) => void;
  busy: boolean;
}): JSX.Element {
  return (
    <Menu
      anchorEl={anchorEl}
      open={anchorEl !== null}
      onClose={onClose}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      transformOrigin={{ vertical: "bottom", horizontal: "center" }}
      sx={{ zIndex: (t) => t.zIndex.modal + 2 }}
      slotProps={{ paper: { sx: { p: 1.5, width: 240 } } }}
    >
      <Typography sx={{ fontSize: 12, fontWeight: 600, color: "text.secondary", mb: 0.75 }}>
        Call a phone number
      </Typography>
      <Keypad
        onSubmit={onDial}
        submitLabel="Call"
        submitBusyLabel="Dialing…"
        submitIcon={<CallIcon />}
        busy={busy}
      />
    </Menu>
  );
}
